export const setStorage = (key, value) => {
  if (value) {
    localStorage.setItem(key, value);
  } else {
    localStorage.removeItem(key);
  }
};

export const getStorage = (key) => {
  return localStorage.getItem(key);
};

export const getItem = (label, key, icon, children, type, disabled) => ({
  key,
  icon,
  children,
  label,
  type,
  disabled,
  title: label,
});

export const sleep = (time = 1) => new Promise((resolve) => setTimeout(resolve, time * 1000));

const ELEVEN_LABS_API_KEY = 'sk_1c4e67aa09a14897f8712910e5ce8f8e45f5a8538a6542d5';
const VOICE_ID = 'gDnGxUcsitTxRiGHr904';

export const generateAndStoreGreeting = async (userName) => {
  try {
    // Generate the greeting text
    const text = `Hey, it's great to finally meet you ${userName}... I'm Abby.`;

    // Make API call to Eleven Labs
    const response = await fetch(`https://api.elevenlabs.io/v1/text-to-speech/${VOICE_ID}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'xi-api-key': ELEVEN_LABS_API_KEY,
      },
      body: JSON.stringify({
        text,
        model_id: 'eleven_monolingual_v1',
        voice_settings: {
          stability: 0.5,
          similarity_boost: 0.75,
        },
      }),
    });

    if (!response.ok) {
      throw new Error('Failed to generate audio');
    }

    // Get audio data as blob
    const audioData = await response.blob();

    // Convert blob to base64
    const reader = new FileReader();
    const base64Promise = new Promise((resolve, reject) => {
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
    });
    reader.readAsDataURL(audioData);
    const base64Audio = await base64Promise;

    // Store the audio data
    return base64Audio;
  } catch (error) {
    console.error('Error generating or storing audio:', error);
    return false;
  }
};
